<template>
  <div>
    <vm-table
        ref="vmTable"
        height="62vh"
        :filter.sync="filter"
        module="basic"
        url="emRepairOrderDetails"
        @select="selectTest"
        @select-all="selectAll">
      <div slot="toolbar">
        <el-button
            v-if="editAuth"
            type="primary"
            @click="$refs.editEMRepairOrderDetail.open(0)">
          新建
        </el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="工单编号">
            <el-input v-model.trim="filter.orderNo" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column type="selection" align="center" width="50"/>
      <el-table-column prop="orderNo" width="120px" align="center" label="工单编号"/>
      <el-table-column prop="repairMethod" width="80px" align="center" label="修理方法">
        <template slot-scope="scope">
          <span>{{constant.dealMethod[scope.row.repairMethod]}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="beginTime" width="140px" align="center" label="开始时间"/>
      <el-table-column prop="endTime" width="140px" align="center" label="结束时间"/>
      <el-table-column prop="estimatedCost" width="80px" align="center" label="预估费用"/>
      <el-table-column prop="repairMan" width="80px" align="center" label="修理人员"/>
      <el-table-column prop="repairContent" align="center" label="维修内容"/>
      <el-table-column
          label="操作"
          align="center"
          class-name="vm-table_operate"
          width="120px">
        <template slot-scope="scope">
          <el-button v-if="editAuth" type="primary" @click="$refs.editEMRepairOrderDetail.open(scope.row.pkid)">编辑</el-button>
          <el-button type="danger" @click="oneDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <e-m-repair-order-detail-edit ref="editEMRepairOrderDetail" @save-success="getList(1)"/>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import constant from "../../../util/constant";
  import constants from "../../../util/constants";
  import EMRepairOrderDetailEdit from "@/views/em/EMRepairOrderDetail/EMRepairOrderDetailEdit";

  export default {
    name: "EMRepairOrderDetailList",
    components: {EMRepairOrderDetailEdit, VmTable,VmSearch},
    data() {
      return {
        constant,
        constants,
        editAuth: this.$auth(91),
        idList: "",
        searchTime: "",
        exportLoading: false,
        exportDetailLoading: false,
        filter: {
          orderNo: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      selectTest(selection) {
        this.idList = selection;
      },
      selectAll(selection) {
        this.idList = selection;
        console.log(selection);
      },
      // 单项删除
      oneDelete(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic","emRepairOrderDetails",row.pkid).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            });
        });
      },
    },
  };
</script>

<style scoped>

</style>
